// Category B/C Supabase identifiers and public refs.
// Source of truth: this file. Do NOT add these identifiers to vault.
// Classification policy: docs/vault/CLASSIFICATION.md
// Last updated: 2026-05-22 (vault-hygiene migration)

export const SUPABASE_PUBLIC_IDS = {
  prodUrl: "https://ewsahqwtupghisvbekvf.supabase.co",
  prodAnonKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV3c2FocXd0dXBnaGlzdmJla3ZmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjMxMzIxNzEsImV4cCI6MjA3ODcwODE3MX0.Rjuad3VfJMFb3BxqTPFaKh7Avf608SFdJKos9QK3yxk",
} as const;

export const DEVELOPMENT_AUTH_BROKER_URL = 'https://bizrnr.com/api/internal/development-auth';
